// src/components/RideBottomNav.js
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const RideBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Hide on desktop
  if (window.innerWidth > 768) return null;

  const isActive = (path) =>
    location.pathname.startsWith(path)
      ? "text-blue-600 font-bold"
      : "text-gray-500";

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-300 z-50 flex justify-around items-center py-3 shadow-md">

      {/* Home */}
      <button
        onClick={() => navigate("/dashboard")}
        className="flex flex-col items-center"
      >
        <span className={`text-xs ${isActive("/dashboard")}`}>Home</span>
      </button>

      {/* My Rides */}
      <button
        onClick={() => navigate("/ride/my-rides")}
        className="flex flex-col items-center"
      >
        <span className={`text-xs ${isActive("/ride/my-rides")}`}>
          My Rides
        </span>
      </button>

      {/* Post Ride */}
      <button
        onClick={() => navigate("/ride/post")}
        className="flex flex-col items-center"
      >
        <span className={`text-xs ${isActive("/ride/post")}`}>
          Post Ride
        </span>
      </button>

      {/* Requests */}
      <button
        onClick={() => navigate("/ride/requests")}
        className="flex flex-col items-center"
      >
        <span className={`text-xs ${isActive("/ride/requests")}`}>
          Requests
        </span>
      </button>
    </div>
  );
};

export default RideBottomNav;
